import { render, staticRenderFns } from "./Verification.vue?vue&type=template&id=4c42e3b5"
import script from "./Verification.vue?vue&type=script&lang=js"
export * from "./Verification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports